/**
 * Helpers for turning work scope edits into API payloads and draft rows.
 */

/**
 * Merge an inline edit into a work scope row.
 *
 * Unit patches arrive as a primary key. The row keeps `{id, name}` so the
 * select, sort, and search keep using the unit name while the save is in flight.
 *
 * @param {Object|null} draft - Current work scope row.
 * @param {Object} patch - Fields changed in the draft.
 * @param {Array<{id: number, name: string}>} units - Unit options.
 * @returns {Object|null}
 */
export function mergeWorkScopeDraft(draft, patch, units) {
  if (!draft) return draft;
  const next = { ...draft, ...patch };
  if (Object.prototype.hasOwnProperty.call(patch, "unit")) {
    if (patch.unit == null || patch.unit === "") {
      next.unit = null;
    } else {
      const unit = (units || []).find(
        (item) => String(item.id) === String(patch.unit)
      );
      next.unit = unit
        ? { id: unit.id, name: unit.name }
        : { id: Number(patch.unit), name: "" };
    }
  }
  return next;
}

/**
 * Create-body for a draft that has a title.
 *
 * @param {Object} row - Draft row.
 * @returns {Object}
 */
export function workScopeCreatePayload(row) {
  const unitId =
    row.unit && typeof row.unit === "object"
      ? row.unit.id
      : row.unit ?? null;
  return {
    title: String(row.title || "").trim(),
    unit: unitId === "" ? null : unitId,
    active: row.active !== false,
  };
}
